import { CSSObject } from '@emotion/react';

export function hoverStyles(hoverStyle: CSSObject): CSSObject {
    return {
        '@media (hover: hover)': {
            '&:hover': hoverStyle,
        },
        '@media (hover: none)': {
            '&:active': hoverStyle,
        },
    };
}
